import React, { useState } from "react";
import "./Services.css";

export default function Services() {
  const [togglestate, setToggle] = useState(0);

  return (
    <section className="services section" id="services">
      <h3 className="section__title">Services</h3>
      <span className="section__subtitle">What i offer</span>
      <div className="services__container container grid">
        <div className="services__content">
          <div>
            <i className="bx bx-windows services__icon"></i>
            <h3 className="services__title">Application Customization</h3>
          </div>
          <span className="services__button" onClick={() => setToggle(1)}>
            View more
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>
          <div
            className={
              togglestate === 1
                ? "services__modal active__modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                className="uil uil-times services__modal-close"
                onClick={() => setToggle(0)}
              ></i>
              <h3 className="services__modal-title">
                Application Customization
              </h3>
              <p className="services__modal-description">
                Proven Customization Expertise
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Architected and supported a custom scoped application within
                    WSD, including development of scoped tables,ACLs,BRs and
                    catalog items.{" "}
                  </p>
                </li>
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Designed and deployed numerous custom flows using Flow
                    Designer to automate complex business logic involving over
                    700+ catalog items tailored to the WSD
                  </p>
                </li>
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Engineered end-to-end customizations across Case Management,
                    B2B/B2C data models, Account Relationships, Advanced Work
                    Assignment (AWA), and Agent Workspace.{" "}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="services__content">
          <div>
            <i className="bx bx-code-alt services__icon"></i>
            <h3 className="services__title">ServiceNow Transformation</h3>
          </div>
          <span className="services__button" onClick={() => setToggle(2)}>
            View more
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>
          <div
            className={
              togglestate === 2
                ? "services__modal active__modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                className="uil uil-times services__modal-close"
                onClick={() => setToggle(0)}
              ></i>
              <h3 className="services__modal-title">
                ServiceNow Transformation
              </h3>
              <p className="services__modal-description">
                Process re-engineering
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Re-architected legacy ITSM configurations into a clean,
                    maintainable scoped application structure, reducing
                    technical debt and improving upgrade compatibility
                  </p>
                </li>
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Implemented best-practice design patterns using Flow
                    Designer over legacy workflows, optimized Business Rules
                    execution order, and minimized client-side scripting for
                    performance improvements.
                  </p>
                </li>
                {/* <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    I develop the user interface
                  </p>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="services__content">
          <div>
            <i className="bx bx-chip services__icon"></i>
            <h3 className="services__title">ServiceNow Integration</h3>
          </div>
          <span className="services__button" onClick={() => setToggle(3)}>
            View more
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>
          <div
            className={
              togglestate === 3
                ? "services__modal active__modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                className="uil uil-times services__modal-close"
                onClick={() => setToggle(0)}
              ></i>
              <h3 className="services__modal-title">ServiceNow Integration</h3>
              <p className="services__modal-description">
                Integration Expertise
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Hands-on experience delivering inbound and outbound
                    REST/SOAP integrations with enterprise platforms including
                    Salesforce, Oracle Fusion, and eBonding solutions to enable
                    seamless system connectivity and data exchange.{" "}
                  </p>
                </li>
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Extensive experience with Service Graph Connectors ( SG
                    Connectors) for seamless integration with AWS,Azure and JAMF
                    enabling automated discovery, data normalization, and CMDB
                    population from AWS resources.
                  </p>
                </li>
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Leveraged ServiceNow ETL capabilities using Import Sets and
                    Export Sets for structured data transformation and
                    migration, along with data extraction via FTP, HTTP, ODBC,
                    and JDBC integrations.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
